module.exports = __webpack_public_path__ + "fonts/GothamMedium.77171d8f.ttf";